import { render } from "./RCBCOpeningView.vue?vue&type=template&id=11765dfb&scoped=true"
import script from "./RCBCOpeningView.vue?vue&type=script&lang=js"
export * from "./RCBCOpeningView.vue?vue&type=script&lang=js"

import "./RCBCOpeningView.vue?vue&type=style&index=0&id=11765dfb&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11765dfb"]])

export default __exports__